import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { SiteHeader, SiteHeaderBrand, SiteHeaderNav, SiteHeaderNavItem, Button } from '@gjl/ui'
import { cn } from '@/lib/cn'
import { navLinks, contactCTA, brand } from '@/lib/nav-links'
import { MobileNav } from './MobileNav'

export function Header() {
  const [isScrolled, setIsScrolled] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className="glass-subtle fixed top-0 right-0 left-0 z-50 transition-all duration-300">
      <div className={cn('transition-all duration-300', isScrolled ? 'py-3' : 'py-4 md:py-6')}>
        <SiteHeader
          className="text-foreground !border-0 !bg-transparent !py-0"
          brand={
            <SiteHeaderBrand href="/" className="text-2xl font-bold md:text-3xl">
              <span className="text-primary">&lt;</span>
              {brand}
              <span className="text-primary">/&gt;</span>
            </SiteHeaderBrand>
          }
          nav={
            <>
              {/* Desktop nav */}
              <SiteHeaderNav className="ml-auto hidden items-center gap-x-6 md:flex">
                {navLinks.map(({ href, label }) => (
                  <SiteHeaderNavItem
                    key={href}
                    href={href}
                    active={location.pathname === href}
                    className="text-muted-foreground hover:text-primary transition-colors"
                  >
                    {label}
                  </SiteHeaderNavItem>
                ))}
                <div className="ml-2 flex items-center">
                  <Button
                    asChild
                    className="gradient-cyber text-primary-foreground hover:glow-cyber-sm transition-shadow"
                  >
                    <Link to={contactCTA.href}>{contactCTA.label}</Link>
                  </Button>
                </div>
              </SiteHeaderNav>

              {/* Mobile nav trigger */}
              <MobileNav />
            </>
          }
        />
      </div>
    </div>
  )
}
